import { i18next } from '../i18n/i18n'
import { getContainer, TYPES } from '../../mvlabs-components-fe/services/binding'
import { TranslationService } from '../../mvlabs-components-fe/services/translation'

function initTranslation(container: ReturnType<typeof getContainer>) {
  container.bind<TranslationService>(TYPES.TranslationService).toConstantValue(new TranslationService(i18next))
}

export default initTranslation
